import { ApiError } from '@/api/client';

/**
 * NAV e-számla partner-validációs hiba → i18n toast-kulcs (vagy null, ha nem partner-eredetű).
 *
 * A #607 BE-contract strukturált `error.code`-jára branch-el (NAV_PARTNER_NOT_FOUND /
 * NAV_PARTNER_INCOMPLETE) — NEM message-substring-re, így i18n-biztos. `null`, ha a hiba nem
 * NAV-partner-eredetű → a hívó a meglévő generikus error-ágra esik (graceful: régi BE / hálózati
 * hiba / más code → null → a #607-merge ELŐTT is biztonságos, nem ad félrevezető toast-ot).
 *
 * Minta: `sales/pos-payment.ts` `loyaltyErrorToastKey` (#603/#605) — de itt `string | null`,
 * mert a `handleSendEInvoice` a NAV-partner-hibára warning-toast-ot, minden más hibára a
 * meglévő generikus alert-et adja (a blast-radius minimális).
 */
export function navPartnerErrorKey(error: unknown): string | null {
  const code = error instanceof ApiError ? error.code : undefined;
  switch (code) {
    case 'NAV_PARTNER_NOT_FOUND':
      return 'invoice.eInvoice.partnerNotFound';
    case 'NAV_PARTNER_INCOMPLETE':
      return 'invoice.eInvoice.partnerIncomplete';
    default:
      return null;
  }
}
